import {useCallback, useState} from "react";
import {validateInputRules} from "../../../common/generic-react.functions.js";
import {useGetInput, useInputRules} from "../../../common/generic-react.rules.js";
export function useGeneratedRules({
  rules
}) {
  const allRules = useInputRules();
  const getRules = useCallback(() => [...Object.values(allRules), ...rules || []], [allRules, rules]);
  const [mainRules] = useState(() => getRules());
  return [mainRules];
}
export function useValidationInput({
  inputRef,
  rules
}) {
  const [mainRules] = useGeneratedRules({
    rules
  });
  const [input] = useGetInput({
    inputRef
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [validateOnChange, setValidateOnChange] = useState(false);
  const isValidInput = useCallback((showErrors = true) => {
    const val = input?.value || "";
    let error = "";
    if (showErrors) {
      setErrorMessage(error);
    }
    if (mainRules?.length) {
      error = validateInputRules(mainRules, val.toString(), input);
      if (error && showErrors) {
        setErrorMessage(error);
      }
    }
    return !error;
  }, [input, mainRules]);
  return {
    errorMessage: [errorMessage, setErrorMessage],
    validateOnChange: [validateOnChange, setValidateOnChange],
    isValidInput
  };
}
